import {
    POPUP_SHOW_NOTIFICATION,
    POPUP_HIDE_NOTIFICATION,
} from 'store/actions/notificationActions';
import { LOCATION_CHANGE } from 'connected-react-router';
import { PATH_FOR_LOGIN } from 'util/constants';

const initialState = [];

let previousPathname = '';
let previousHash = '';

export default (previousState = initialState, { type, payload, newNotification, notificationKey }) => {
    switch (type) {
        case LOCATION_CHANGE:
            if( previousPathname !== payload.location.pathname ) {
                const previous = previousPathname.split("/");
                const now = payload.location.pathname.split("/");
                previousPathname = payload.location.pathname;
                if( previous[1] !== now[1] && payload.location.pathname !== PATH_FOR_LOGIN ) { // 로그아웃 Noti를 유지하기 위해 로그인페이지는 제외
                    return initialState;
                }
            } else {
                if(previousHash !== payload.hash) { // 팝업 닫을때 이전 남아있는 알림 삭제되게 수정 ==> payload.hash 맞는지 확인. payload.location.hash
                    previousPathname = payload.location.pathname;
                    previousHash = payload.hash;

                    return initialState;
                }
            }
            return previousState;

        case POPUP_SHOW_NOTIFICATION:
            return [
                ...previousState,
                newNotification
            ];

        case POPUP_HIDE_NOTIFICATION:
            if(!notificationKey) { // notificationKey 없이 호출한 경우 이전 알림 모두 삭제되게 수정 
                return initialState;
            }
            return previousState.filter(notification => notification.key !== notificationKey);

        default:
            return previousState;
    }
};
